import { combineReducers } from 'redux';
import searchNotifications from '../Notifications/components/recipients_tab/components/recipients_table/redux/index';
import notificationEventsOverview from '../NotificationEventsOverview/redux/index';
import configureNotification from '../configure_notification/redux/configure-notification-slice';
import deleteNotifications from '../Notifications/components/Overview/redux/deleteNotifications';
import notificationFormData from '../configure_notification/redux/notification-form-data';
import selectedSurveyType from '../../rise/notification/configure_notification/redux/selectedSurveyType';
import configureAttachmentState from '../configure_notification/redux/configureAttachmentState';
import createNotificationSchedule from '../Notifications/components/Overview/redux/createNotificationSchedule';
import getNotificationDetails from '../Notifications/components/Overview/redux/getNotificationDetails';
import cancelScheduledNotification from '../Notifications/components/Overview/redux/cancelScheduledNotification';
import getRnDTeamMembers from '../Notifications/components/Overview/redux/getRnDTeamMembers';
import triggerTestCampaign from '../Notifications/components/Overview/redux/triggerTestCampaign';
import configureTemplateState from '../configure_notification/redux/configureTemplateState';

export default combineReducers({
  notificationEventsOverview,
  searchNotifications,
  configureNotification,
  configureAttachmentState,
  notificationFormData,
  selectedSurveyType,
  deleteNotifications,
  createNotificationSchedule,
  getNotificationDetails,
  cancelScheduledNotification,
  configureTemplateState,
  triggerTestCampaign,
  getRnDTeamMembers,
});
